import appStore from './appStore'
import localeStore from './LocaleStore'
import roleStore from '../Backend/dongfeng/system/Role/store'
import userStore from '../Backend/dongfeng/system/User/store'
import userOperationRecordStore from '../Backend/dongfeng/UserOperationRecord/store'
import goodsStore from '../Backend/dongfeng/Goods/store'
import motorcycleTypeStore from '../Backend/common/MotorcycleType/store'
import carseriesStore from '../Backend/common/Carseries/store'
import brandStore from '../Backend/common/Brand/store'
import maintainDirectoryStore from '../Backend/dongfeng/maintain/Directory/store'
import maintainContentStore from '../Backend/dongfeng/maintain/Content/store'
import approvalStore from '../Backend/dongfeng/maintain/Approval/store'
import manualStore from '../project/dongfeng/web/maintain/Manual/store'
import printStore from '../project/dongfeng/web/maintain/PrintContent/store'
import mainTainCarSeriesStore from '../project/dongfeng/web/maintain/CarSeries/store'
import receiverStore from '../project/dongfeng/web/receiver/Receiver/store'
import tbCarSeriesStore from '../project/dongfeng/technicalBriefing/TBCarSeries/store'
import tbContentStore from '../project/dongfeng/technicalBriefing/TBContent/store'
import tbArticleStore from '../project/dongfeng/technicalBriefing/TBArticle/store'
import easyReportContentStore from '../Backend/dongfeng/Briefing/BriefingContent/store'
import easyReportDirectoryStore from '../Backend/dongfeng/Briefing/BriefingDirectory/store'
import easyReportApprovalStore from '../Backend/dongfeng/Briefing/BriefingApproval/store'
import homeStore from '../project/dongfeng/homePage/content/Home/store'
import listsStore from '../project/dongfeng/homePage/content/Lists/store'
import contentStore from '../project/dongfeng/homePage/content/Content/store'
import cmsNewsStore from '../Backend/dongfeng/CMS/CMSNews/store'
import cmsPageStore from '../Backend/dongfeng/CMS/CMSPage/store'
import cmsCategoryStore from '../Backend/dongfeng/CMS/CMSCategory/store'
import eAtlasContentStore from '../Backend/dongfeng/EAtlas/EAtlasContent/store'
import eAtlasApprovalStore from '../Backend/dongfeng/EAtlas/EAtlasApproval/store'
import eAtlasCarSeriesCatalogStore from '../Backend/dongfeng/EAtlas/EAtlasCarSeriesCatalog/store'
import eAtalsCarSeriesStore from '../project/dongfeng/eAtlas/EAtalsCarseries/store'
import eAtalsContentsStore from '../project/dongfeng/eAtlas/EAtalsContent/store'
import eAtalsBigPicStore from '../project/dongfeng/eAtlas/EAtalsBigPic/store'
import productIndexStore from '../project/dongfeng/products/Main/store'
import productDetailStore from '../project/dongfeng/products/Details/store'
import faultCaseContentMaintenanceStore from '../Backend/dongfeng/FaultDiagnosis/FaultCaseContentMaintenance/store'
import faultStore from '../Backend/dongfeng/FaultDiagnosis/FaultCaseContentMaintenance/faultStore'
import faultCaseCarseriesMaintenanceStore from '../Backend/dongfeng/FaultDiagnosis/FaultCaseCarseriesMaintenance/store'
import faultCaseFaultMaintenanceStore from '../Backend/dongfeng/FaultDiagnosis/FaultCaseFaultMaintenance/store'
import faultCaseCriteriaMaintenanceStore from '../Backend/dongfeng/FaultDiagnosis/FaultCaseCriteriaMaintenance/store'
import faultCasePhenomenonMaintenanceStore from '../Backend/dongfeng/FaultDiagnosis/FaultCasePhenomenonMaintenance/store'
import faultCaseSystemMaintenanceStore from '../Backend/dongfeng/FaultDiagnosis/FaultCaseSystemMaintenance/store'
import faultCaseErrorCodeMaintenanceStore from '../Backend/dongfeng/FaultDiagnosis/FaultCaseErrorCodeMaintenance/store'
import faultDiagnosisCarSeriesStore from '../project/dongfeng/faultDiagnosis/main/CarSeries/store'
import frontFaultDiagnosisStore from '../project/dongfeng/faultDiagnosis/demo/Datasource'
import faultDiagnosisIndexStore from '../project/dongfeng/faultDiagnosis/main/IndexDiagnosis/store'
import faultDContentStore from '../project/dongfeng/faultDiagnosis/main/Content/store'
import faultDCodeContentStore from '../project/dongfeng/faultDiagnosis/main/CodeContent/store'
import hotPointStore from '../Backend/dongfeng/HotPoint/store'
import verificationStore from '../Backend/dongfeng/Verification/store'
import boutiqueTypeStore from '../Backend/dongfeng/BoutiqueCatalog/BoutiqueType/store'
import boutiqueAttrStore from '../Backend/dongfeng/BoutiqueCatalog/BoutiqueAttr/store'
import boutiqueTrainManagementStore from '../Backend/dongfeng/BoutiqueCatalog/BoutiqueTrainManagement/store'
import boutiqueActivityStore from '../Backend/dongfeng/BoutiqueCatalog/BoutiqueActivity/store'
import boutiqueGoodsStore from '../Backend/dongfeng/BoutiqueCatalog/BoutiqueGoods/store'
import toolModelStore from '../Backend/dongfeng/ToolManual/ToolModel/store'
import toolMaintainStore from '../Backend/dongfeng/ToolManual/ToolMaintain/store'
import hoursCatalogManagerStore from '../Backend/dongfeng/HoursManual/HoursCatalogManager/store'
import hoursContentManagerStore from '../Backend/dongfeng/HoursManual/HoursContentManager/store'
import hoursHotspotManagerStore from '../Backend/dongfeng/HoursManual/HoursHotspotManager/store'
import hoursStepManagerStore from '../Backend/dongfeng/HoursManual/HoursStepManager/store'
import serviceStationStore from '../Backend/dongfeng/ServiceStation/store'
import toolkitStore from '../project/dongfeng/toolkit/Home/store'
import toollistStore from '../project/dongfeng/toolkit/ToolList/store'
import toolMethodStore from '../project/dongfeng/toolkit/ToolMethod/store'
import toolkitIdStore from '../project/dongfeng/toolkit/ToolkitId/store'
import toolContentStore from '../project/dongfeng/toolkit/ToolContent/store'
import userLoginRecordStore from  '../Backend/dongfeng/UserLoginRecord/store'
import carBrandStore from '../Backend/sparePartsCatalogue/basicDataOfAutomobile/Brand/store'
import carseriesManagerStore from '../Backend/sparePartsCatalogue/basicDataOfAutomobile/Carseries/store'
import newsStore from '../Backend/sparePartsCatalogue/sparePartsCatalogueNews/News/store'
import pageStore from '../Backend/sparePartsCatalogue/sparePartsCatalogueNews/Page/store'
import categoryStore from '../Backend/sparePartsCatalogue/sparePartsCatalogueNews/Category/store'
import languageManagerStore from '../Backend/sparePartsCatalogue/LanguageManager/store'
import systemDictionaryStore from '../Backend/sparePartsCatalogue/SystemDictionary/store'
import knowledgeBaseStore from '../Backend/sparePartsCatalogue/KnowledgeBase/store'
import answerCenterStore from '../Backend/dongfeng/AnswerPlatform/AnswerCenter/store'
import answerQuestionStore from '../Backend/dongfeng/AnswerPlatform/AnswerQuestion/store'
import answerStatisticsStore from '../Backend/dongfeng/AnswerPlatform/AnswerStatistics/store'
import letterNoticeStore from '../Backend/sparePartsCatalogue/LetterNotice/store'
import noticeBreakPointStore from '../Backend/sparePartsCatalogue/LetterNotice/NoticeBreakPoint/store'
import salesStore from '../Backend/sparePartsCatalogue/Sales/store'
import carseriesConfigurationStore from '../Backend/sparePartsCatalogue/CarseriesConfiguration/store'
import masterSparepartStore from '../Backend/sparePartsCatalogue/sbom/MasterSparepart/store'
import researchSbomStore from '../Backend/sparePartsCatalogue/sbom/ResearchSBOM/store'
import newSbomStore from '../Backend/sparePartsCatalogue/sbom/NewBom/store'
import sluggishCategoryStore from '../Backend/sparePartsCatalogue/SluggishCategory/store'
import epcCarDirectoryStore from '../Backend/sparePartsCatalogue/EPC/EPCCatalogManager/store'
import epcChapterMainStore from '../Backend/sparePartsCatalogue/basicDataOfAutomobile/EPCChapterMain/store'
import epcSparepartCatalogAttributeStore from '../Backend/sparePartsCatalogue/EPC/EPCSparepartCatalogAttribute/store'
import epcSparepartCatalogConfigStore from '../Backend/sparePartsCatalogue/EPC/EPCSparepartCatalogConfig/store'
import epcSparepartDefinationStore from '../Backend/sparePartsCatalogue/EPC/EPCSparepartDefination/store'
import epcPhotoManagerStore from '../Backend/sparePartsCatalogue/EPC/EPCPhotoManager/store'
import epcCatalogVerificationStare from '../Backend/sparePartsCatalogue/EPC/EPCCatalogVerification/store'
import epcSparepartCatalogTechnologyStore from '../Backend/sparePartsCatalogue/EPC/EPCSparepartCatalogTechnology/store'
import epcSparepartChangeStore from '../Backend/sparePartsCatalogue/EPC/EPCSparepartChange/store'
import vehicleDepartmentsQueryStore from '../project/VehicleDepartmentsQuery/store'
import journalismStore from '../project/dongfeng/Journalism/store'
import shoppingCartStore from '../project/dongfeng/ShoppingCart/store'
import sparePartsPertainToAudiStore from '../project/dongfeng/SparePartsPartainToAudi/store'
import sparePartsChangeQueryStore from '../project/dongfeng/SparePartsChangeQuery/store'
import frontAnswerCenterStore from '../project/dongfeng/AnswerCenter/store'
import frontKnowledgeBaseStore from '../project/dongfeng/KnowledgeBase/store'
import orderHistoryStore from '../project/dongfeng/OrderHistory/store'
import zcysvehicleDepartmentsQueryStore from '../project/frontZCYS/VehicleDepartmentsQuery/store'
import carsModelStore from '../Backend/sparePartsCatalogue/CarsModel/store'
import taskManagementStore from '../Backend/sparePartsCatalogue/TaskManagement/store'
import backgroundOperationRecordStore from '../Backend/sparePartsCatalogue/BackgroundOperationRecord/store'
import specialToolListStore from '../Backend/dongfeng/specialTool/SpecialToolList/store'
import specialToolCatalogManagerStore from '../Backend/dongfeng/specialTool/SpecialToolCatalogManager/store'
import repairFolderStore from '../Backend/dongfeng/maintain/RepairFolder/store'
import briefingFolderStore from '../Backend/dongfeng/Briefing/BriefingFolder/store'
import circuitFolderStore from '../Backend/dongfeng/EAtlas/EAtlasFolder/store'
import hoursFolderStore from '../Backend/dongfeng/HoursManual/HoursFolder/store'
import specialFolderStore from '../Backend/dongfeng/specialTool/SpecialFolder/store'
import manualCatalogStore from '../Backend/dongfeng/manual/manualCatalog/store'
import manualContentStore from '../Backend/dongfeng/manual/manualContent/store'
import manualCarseriesStore from '../project/dongfeng/manual/Carseries/store'
import userManualContentsStore from '../project/dongfeng/manual/Content/store'
import repairManualFolderStore from '../project/dongfeng/web/maintain/Folder/store'
import hoursManualFolderStore from '../project/dongfeng/toolTimeManual/ToolTimeFolder/store'
import eAtlasFolderStore from '../project/dongfeng/eAtlas/EAtalsFolder/store'
import detailsOfNonLoadingPartsStore from '../Backend/sparePartsCatalogue/DetailsOfNonLoadingParts/store'
import frontDeskOperationRecordStore from '../Backend/sparePartsCatalogue/FrontDeskOperationRecord/store'
import overseasCustomizationStore from '../project/frontZCYS/OverseasCustomization/store'
import assemblyTempStore from '../Backend/sparePartsCatalogue/AssemblyTemp/store'
import newBOMManagementStore from '../Backend/sparePartsCatalogue/sbom/NewBOMManagement/store'
import partInformationChangeStore from '../Backend/sparePartsCatalogue/sbom/PartInformationChange/store'
import yjVehicleDepartmentsQueryStore from '../project/yijing/VehicleDepartmentsQuery/store'
import yjSparePartsPertainToAudiStore from '../project/yijing/SparePartsPartainToAudi/store'
import yjFrontKnowledgeBaseStore from '../project/yijing/KnowledgeBase/store'

const stores = {
    appStore,
    localeStore,
    roleStore,
    userStore,
    userOperationRecordStore,
    goodsStore,
    maintainDirectoryStore,
    brandStore,
    carseriesStore,
    motorcycleTypeStore,
    maintainContentStore,
    manualStore,
    mainTainCarSeriesStore,
    approvalStore,
    receiverStore,
    easyReportContentStore,
    easyReportDirectoryStore,
    tbCarSeriesStore,
    tbContentStore,
    tbArticleStore,
    easyReportApprovalStore,
    homeStore,
    listsStore,
    contentStore,
    cmsNewsStore,
    cmsPageStore,
    cmsCategoryStore,
    printStore,
    eAtlasContentStore,
    eAtlasApprovalStore,
    eAtlasCarSeriesCatalogStore,
    eAtalsCarSeriesStore,
    eAtalsContentsStore,
    eAtalsBigPicStore,
    faultCaseContentMaintenanceStore,
    faultStore,
    faultCaseCarseriesMaintenanceStore,
    faultCaseFaultMaintenanceStore,
    faultCaseCriteriaMaintenanceStore,
    faultCasePhenomenonMaintenanceStore,
    faultCaseSystemMaintenanceStore,
    faultCaseErrorCodeMaintenanceStore,
    faultDContentStore,
    faultDCodeContentStore,
    faultDiagnosisCarSeriesStore,
    frontFaultDiagnosisStore,
    faultDiagnosisIndexStore,
    productIndexStore,
    productDetailStore,
    hotPointStore,
    verificationStore,
    boutiqueTypeStore,
    boutiqueAttrStore,
    boutiqueActivityStore,
    boutiqueGoodsStore,
    toolModelStore,
    toolMaintainStore,
    hoursCatalogManagerStore,
    hoursContentManagerStore,
    hoursHotspotManagerStore,
    serviceStationStore,
    hoursStepManagerStore,
    toolkitStore,
    toollistStore,
    toolMethodStore,
    toolkitIdStore,
    toolContentStore,
    carBrandStore,
    carseriesManagerStore,
    newsStore,
    specialToolListStore,
    specialToolCatalogManagerStore,
    userLoginRecordStore,
    boutiqueTrainManagementStore,
    pageStore,
    categoryStore,
    languageManagerStore,
    systemDictionaryStore,
    knowledgeBaseStore,
    answerCenterStore,
    answerQuestionStore,
    answerStatisticsStore,
    letterNoticeStore,
    noticeBreakPointStore,
    salesStore,
    carseriesConfigurationStore,
    masterSparepartStore,
    researchSbomStore,
    newSbomStore,
    sluggishCategoryStore,
    epcCarDirectoryStore,
    epcChapterMainStore,
    epcSparepartCatalogAttributeStore,
    epcSparepartCatalogConfigStore,
    epcSparepartDefinationStore,
    epcPhotoManagerStore,
    epcCatalogVerificationStare,
    epcSparepartCatalogTechnologyStore,
    epcSparepartChangeStore,
    vehicleDepartmentsQueryStore,
    journalismStore,
    shoppingCartStore,
    sparePartsPertainToAudiStore,
    sparePartsChangeQueryStore,
    frontAnswerCenterStore,
    frontKnowledgeBaseStore,
    orderHistoryStore,
    zcysvehicleDepartmentsQueryStore,
    carsModelStore,
    taskManagementStore,
    backgroundOperationRecordStore,
    repairFolderStore,
    briefingFolderStore,
    circuitFolderStore,
    hoursFolderStore,
    specialFolderStore,
    manualCatalogStore,
    manualContentStore,
    manualCarseriesStore,
    userManualContentsStore,
    repairManualFolderStore,
    hoursManualFolderStore,
    eAtlasFolderStore,
    detailsOfNonLoadingPartsStore,
    frontDeskOperationRecordStore,
    overseasCustomizationStore,
    assemblyTempStore,
    newBOMManagementStore,
    partInformationChangeStore,
    yjVehicleDepartmentsQueryStore,
    yjSparePartsPertainToAudiStore,
    yjFrontKnowledgeBaseStore,
}
export default stores


// WEBPACK FOOTER //
// ./src/stores/index.js